import { Typography } from '@mui/material';
import React from 'react';
import styled from '@emotion/styled';

const StyledPara = styled(Typography)`
  font-size: 60px;
  font-weight: 480;
  
  @media(max-width: 600px) {
    font-size: 45px;
  }
`;

const Heading = (props) => {
  const { children, style } = props; 
  return (
    <StyledPara
      variant="h4"
      color="#030930"
      style={style} 
      {...props} 
    >
      {children}
    </StyledPara>
  );
};

export default Heading;
